import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UkmrvShipViewComponent } from './ukmrv-ship-view.component';

const routes: Routes = [
  {
    path: '',
    component: UkmrvShipViewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UkmrvShipViewRoutingModule {}
